var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item._kind === 'created')?_c('betriebsanweisungAction',{attrs:{"item":_vm.item,"config":_vm.config},on:{"reloadData":_vm.reload}}):_c('operatingInstructionAction',{attrs:{"item":_vm.item},on:{"reloadData":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }